import React from 'react';
import PropTypes from 'prop-types';
import { addSpaceBeforeCaps } from '../../../utils/common';

const SummaryCard = ({ data, onClose }) => {
  return (
    <>
      <div className="summary-card_overlay" onClick={onClose}></div>
      <div className="summary-card">
        {data.map(summary => (
          <div className="summary-card_row">
            <div className="summary-card_title">
              {addSpaceBeforeCaps(summary.title)}
            </div>
            <div className="summary-card_info">
              {summary.otherInfo.map(info => (
                <div className="summary-card_info_single">
                  <div className="summary-card_info-right">{info.label}</div>
                  <div className="summary-card_info-left">{info.price}</div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

SummaryCard.propTypes = {
  data: PropTypes.array
};

export default SummaryCard;
